import ApiService from '@/utils/ApiService'
import getIdFromLink from '@/utils/getIdFromLink'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    isLoadingUserDataOptions: false,
    isLoadingPaymentsModelOptions: false,
    isSendOfferToAcceptModalVisible: false,
    isSendEmailPropositionModalVisible: false,
    sendOfferToAcceptId: null,
    sendEmailPropositionId: null,
    userData: {},
    isLoadingUserData: false,
    isLoadingWarehouseItem: false,
    agreementTagOptions: [],
    paymentWayOptions: [],
    electronicPaymentTypeOptions: [],
    documentTemplateOptions: [],
    promotionsOptions: [],
    devicesOptions: [],
    agreements: [],
    agreementsMassEdit: [],
    agreementsView: {},
    agreementsTotalItems: 0,
    agreementStatuses: {
      1: 'views.agreements.list.statuses.newAgreement',
      2: 'views.agreements.list.statuses.acceptedAgreement',
      3: 'views.agreements.list.statuses.signedAgreement',
      4: ' - ',
      5: 'views.agreements.list.statuses.signingAgreement'
    },
    paymentsModelOptions: [],
    isLoadingAgreements: false,
    isLoadingAgreementsMassEdit: false,
    agreementTypes: {
      0: 'views.agreements.list.types.contract',
      1: 'views.agreements.list.types.agreementOffer'
    },
    paymentFrequency: {
      12: 'views.agreements.form.paymentFrequency.annual',
      6: 'views.agreements.form.paymentFrequency.semiAnnual',
      3: 'views.agreements.form.paymentFrequency.quarterly',
      1: 'views.agreements.form.paymentFrequency.monthly'
    }
  },
  getters: {
    paymentFrequency: state => state.paymentFrequency,
    getAgreementById: state => id => {
      if (id) {
        return state.agreements.find(agreement => agreement['@id'] === id)
      }
    },
    getAgreementsView: state => state.agreementsView,
    getAgreementsTotalItems: state => state.agreementsTotalItems,
    getIsLoadingPaymentsModelOptions: state => state.isLoadingPaymentsModelOptions,
    getSendOfferToAcceptId: state => state.sendOfferToAcceptId,
    getIsSendOfferToAcceptModalVisible: state => state.isSendOfferToAcceptModalVisible,
    getIsSendEmailPropositionModalVisible: state => state.isSendEmailPropositionModalVisible,
    getSendEmailPropositionId: state => state.sendEmailPropositionId,
    getAgreementTypes: state => state.agreementTypes,
    getIsLoadingAgreements (state) {
      return state.isLoadingAgreements
    },
    getIsLoadingAgreementsMassEdit (state) {
      return state.isLoadingAgreementsMassEdit
    },
    getPaymentsModelOptions (state) {
      return state.paymentsModelOptions.map(model => {
        return { ...model, id: getIdFromLink(model['@id']) }
      })
    },
    getAgreementStatuses: state => state.agreementStatuses,
    getAgreements: state => state.agreements,
    getAgreementsForMassEdit: state => state.agreementsMassEdit,
    getDocumentTemplateOptions (state) {
      let documentTemplates = [{
        text: Vue.prototype.$lang.t('global.notSet'),
        value: null
      }]
      state.documentTemplateOptions.forEach(option => {
        documentTemplates.push({ value: option['@id'], text: option.title, idDefaultBatchNumber: option.idDefaultBatchNumber })
      })
      return documentTemplates
    },
    getElectronicPaymentTypeOptions (state) {
      return state.electronicPaymentTypeOptions.map(option => {
        return { value: option['@id'], text: option.name }
      })
    },
    getPaymentWayOptions (state) {
      return state.paymentWayOptions.map(option => {
        return { value: option['@id'], text: option.name }
      })
    },
    getAgreementTagOptions (state) {
      return state.agreementTagOptions.map(option => {
        return { value: option['@id'], text: option.tag }
      })
    },
    getUserDataOptions (state) {
      return state.userDataOptions.map(option => {
        return { value: option['@id'], text: option.fullName === ' ' ? option.firmname1 : option.fullName }
      })
    },
    getPromotions (state) {
      return state.promotionsOptions.map(option => {
        return { value: option['@id'], text: option.description, canjoin: option.canjoin, promotionValue: option.value, type: option.type }
      })
    },
    getPromotionById: state => id => {
      if (id) {
        return state.promotionsOptions.find(promotionsOptions => promotionsOptions['@id'] === id)
      }
    },
    getDevices (state) {
      return state.devicesOptions.map(option => {
        return { value: option['@id'], text: option.idDeviceModel.idDeviceType.title + ' ' + option.idDeviceModel.idDeviceBrand.brandTitle + ' (' + option.serialNumber + ')' }
      })
    }
  },
  mutations: {
    setAgreementsView (state, payload) {
      state.agreementsView = payload
    },
    setAgreementsTotalItems (state, payload) {
      state.agreementsTotalItems = payload
    },
    togglePaymentsModelOptionsLoading (state) {
      state.isLoadingPaymentsModelOptions = !state.isLoadingPaymentsModelOptions
    },
    toggleSendOfferToAcceptModal (state) {
      state.isSendOfferToAcceptModalVisible = !state.isSendOfferToAcceptModalVisible
    },
    setSendOfferToAcceptId (state, payload) {
      state.sendOfferToAcceptId = payload
    },
    setSendEmailPropositionId (state, payload) {
      state.sendEmailPropositionId = payload
    },
    toggleLoadingAgreements (state) {
      state.isLoadingAgreements = !state.isLoadingAgreements
    },
    toggleLoadingAgreementsMassEdit (state) {
      state.isLoadingAgreementsMassEdit = !state.isLoadingAgreementsMassEdit
    },
    setPaymentsModelOptions (state, payload) {
      state.paymentsModelOptions = payload
    },
    setAgreements (state, payload) {
      state.agreements = payload
    },
    setAgreementsMassEdit (state, payload) {
      state.agreementsMassEdit = payload
    },
    setDocumentTemplateOptions (state, payload) {
      state.documentTemplateOptions = payload
    },
    setElectronicPaymentTypeOptions (state, payload) {
      state.electronicPaymentTypeOptions = payload
    },
    setPaymentWayOptions (state, payload) {
      state.paymentWayOptions = payload
    },
    setPromotionsOptions (state, payload) {
      state.promotionsOptions = payload
    },
    setDevicesOptions (state, payload) {
      state.devicesOptions = payload
    },
    setAgreementTagOptions (state, payload) {
      state.agreementTagOptions = payload
    }
  },
  actions: {
    async fetchWarehouseItemsOptions ({ commit }, params) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_s_b_items', baseParams).getResults()
      commit('setWarehouseItems', await response.items)
    },
    async fetchAgreementTagOptions ({ commit }, params) {
      let baseParams = { pagination: false, tagType: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_c_m_tags', baseParams).getResults()
      commit('setAgreementTagOptions', await response.items)
    },
    async fetchPaymentWayOptions ({ commit }, params) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_s_b_payment_ways', baseParams).getResults()
      commit('setPaymentWayOptions', await response.items)
    },
    async fetchPromotions ({ commit }, params) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_a_b_promotions', baseParams).getResults()
      commit('setPromotionsOptions', await response.items)
    },
    async fetchDevices ({ commit }, params) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_c_m_devices', baseParams).getResults()
      commit('setDevicesOptions', await response.items)
    },
    async fetchElectronicPaymentTypeOptions ({ commit }, params) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_a_b_electronic_payments_types', baseParams).getResults()
      commit('setElectronicPaymentTypeOptions', await response.items)
    },
    async fetchDocumentTemplateOptions ({ commit }, params) {
      let baseParams = { pagination: false, templateType: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('document_templates', baseParams).getResults()
      commit('setDocumentTemplateOptions', await response.items)
    },
    async fetchAgreements ({ commit }, params) {
      let baseParams = {}
      if (!params.hideLoader) {
        commit('toggleLoadingAgreements')
      }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_a_b_agreements', baseParams).getResults()
      if (!params.hideLoader) {
        commit('toggleLoadingAgreements')
      }
      commit('setAgreements', await response.items)
      commit('setAgreementsView', await response.view)
      commit('setAgreementsTotalItems', await response.totalItems)
    },
    async fetchPaymentsModelOptions ({ commit }, params) {
      commit('togglePaymentsModelOptionsLoading')
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_a_b_payments_models', baseParams).getResults()
      commit('togglePaymentsModelOptionsLoading')
      commit('setPaymentsModelOptions', await response.items)
    },
    async sendOfferToAccept ({ commit, state }, params) {
      await new ApiService(`e_x_a_b_agreements/${getIdFromLink(state.sendOfferToAcceptId)}`).put(params)
      commit('toggleSendOfferToAcceptModal')
    },
    async fetchAgreementsForMassEdit ({ commit }, params) {
      let baseParams = {}
      commit('toggleLoadingAgreementsMassEdit')
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_a_b_agreements_mass_edit', baseParams).getResults()
      for (let i in response) {
        response[i].agreementTags = response[i].agreementTags.map(entry => {
          return { '@id': entry['@id'], value: entry.tag['@id'], text: entry.tag.tag }
        })
        response[i].idClientName = response[i].idClient.firmname1 === '' ? (response[i].idClient.name + ' ' + response[i].idClient.surname) : response[i].idClient.firmname1
        response[i].idClient = response[i].idClient['@id']
        response[i].agreementItems = response[i].agreementItems.map(entry => {
          return {
            '@id': entry['@id'],
            item: entry.item['@id'],
            priceUserData: entry.priceUserData,
            dateFrom: entry.dateFrom,
            dateTo: entry.dateTo,
            isCyclic: entry.isCyclic,
            canBeCyclic: !!entry.item.isCyclic,
            hasPromotion: !!entry.promotion,
            promotion: entry.promotion ? entry.promotion['@id'] : null,
            alwaysSettleInFull: entry.alwaysSettleInFull
          }
        })
        response[i].originalAgreementItems = JSON.stringify(response[i].agreementItems)
        response[i].agreementAdditionalItems = response[i].agreementAdditionalItems.map(entry => {
          return {
            '@id': entry['@id'],
            item: entry.item['@id'],
            priceUserData: entry.priceUserData,
            dateFrom: entry.dateFrom,
            dateTo: entry.dateTo,
            isCyclic: entry.isCyclic,
            canBeCyclic: !!entry.item.isCyclic,
            hasPromotion: !!entry.promotion,
            promotion: entry.promotion ? entry.promotion['@id'] : null,
            additionalDocumentTemplate: entry.additionalDocumentTemplate
          }
        })
        response[i].originalAgreementAdditionalItems = JSON.stringify(response[i].agreementAdditionalItems)
        response[i].agreementPromotions = response[i].agreementPromotions.map(entry => {
          return { '@id': entry['@id'], promotion: entry.promotion['@id'] }
        })
        response[i].originalAgreementPromotions = JSON.stringify(response[i].agreementPromotions)
        response[i].agreementsConsents = response[i].agreementsConsents.map(entry => {
          return { '@id': entry['@id'], consent: entry.consent['@id'], agree: entry.agree }
        })
        response[i].agreementDevices = response[i].agreementDevices.map(entry => {
          return { '@id': entry['@id'], device: entry.device['@id'] }
        })
        response[i].agreementAddresses = response[i].agreementAddresses.map(entry => {
          return {
            '@id': entry['@id'],
            idUserDataAddress: entry.idUserDataAddress ? entry.idUserDataAddress['@id'] : null,
            addressType: entry.idUserDataAddress ? entry.idUserDataAddress.addressType : null,
            city: entry.idUserDataAddress ? entry.idUserDataAddress.city : null,
            postcode: entry.idUserDataAddress ? entry.idUserDataAddress.postcode : null,
            province: entry.idUserDataAddress ? entry.idUserDataAddress.province : null,
            street: entry.idUserDataAddress ? entry.idUserDataAddress.street : null
          }
        })
        response[i].isLoading = false
      }
      commit('toggleLoadingAgreementsMassEdit')
      commit('setAgreementsMassEdit', await response)
    }
  }
}
